import { Box, SxProps, Theme } from '@mui/material';

interface BoxWhiteContainerProps {
    children: React.ReactNode;
    sx?: SxProps<Theme>;
}

const BoxWhiteContainer: React.FC<BoxWhiteContainerProps> = ({ children, sx }: BoxWhiteContainerProps) => {
    return (
        <Box
            sx={(theme) => {
                const userSx = typeof sx === 'function' ? sx(theme) : sx || {};
                return {
                    display: 'flex',
                    flexWrap: 'wrap',
                    border: '1px solid #ccc',
                    backgroundColor: '#ffffff',
                    borderRadius: '8px',
                    padding: '16px',
                    gap: '16px',
                    marginBottom: '16px',
                    ...(userSx as object),
                };
            }}
        >
            {children}
        </Box>
    );
}

export default BoxWhiteContainer;
